import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import BanDoChatLuongDatApi from '../../api/BanDoChatLuongDatApi';
import ChuGiaiApi from '../../api/ChuGiaiApi';
import ThongBao from '../../core/ThongBao';
import { Loading } from '../loading/Loading';
import { SelectHuyen } from '../selecthuyen/SelectHuyen';
import { SelectXa } from '../selectxa/SelectXa';


export const ModalChatLuong = (props) => {
    const [show, setShow] = useState(false);
    const { register, handleSubmit, reset } = useForm();
    const [xa, setXa] = useState({});
    const [listDvdds, setListDvdd] = useState([]);
    const [selectedDvdd, setSelectedDvdd] = useState();
    const [listDoDays, setListDoDay] = useState([]);
    const [selectedDoDay, setSelectedDoDay] = useState();
    const [listDoDocs, setListDoDoc] = useState([]);
    const [selectedDoDoc, setSelectedDoDoc] = useState();
    const [listTuois, setListTuoi] = useState([]);
    const [selectedTuoi, setSelectedTuoi] = useState();
    const [listDaLans, setListDaLan] = useState([]);
    const [selectedDaLan, setSelectedDaLan] = useState();
    const [listDoPhis, setListDoPhi] = useState([]);
    const [selectedDoPhi, setSelectedDoPhi] = useState();
    const [listTpcgs, setListTpcg] = useState([]);
    const [selectedTpcg, setSelectedTpcg] = useState();
    const [tuoi, selectTuoi] = useState('');
    const [day, selectDay] = useState('');
    const [doc, selectDoc] = useState('');
    const [dalan, selectDalan] = useState('');
    const [tpcg, selectTpcg] = useState('');
    const [fe, selectFe] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        props.handleClose();
        setShow(false);
    };

    useEffect(() => {
        if (props.showModal === true) {
            reset({
                id: props.thongTin.id,
                maxa: props.thongTin.maxa,
                tenxa: props.thongTin.tenxa,
                dvdd_h: props.thongTin.dvdd_h,
                dt_ha: props.thongTin.dt_ha,
                dungtichha: props.thongTin.dungtichha,
                donobazo: props.thongTin.donobazo,
                tongcation: props.thongTin.tongcation,
                phkcl: props.thongTin.phkcl

            }, [reset]);
            ChuGiaiApi.getChatLuongDat().then((res) => {
                let list = [];



                res.forEach(item => {
                    list.push({
                        value: item.dvdd_h,
                        label: item.dvdd_h,
                        dvdd_h: item.dvdd_h,
                        pctuoi: item.phancaptuoi,
                        pcdoc: item.phancapdoc,
                        pctpcg: item.phancaptpcg,
                        pcdalan: item.phancapdalan,
                        pcdoday: item.phancapdoday,
                        pcfe: item.phancapfe,
                        tuoi: item.tuoi,
                        dodoc: item.dodoc,
                        tpcg: item.tpcg,
                        dalan: item.dalan,
                        doday: item.doday,
                        dophi: item.dophi,
                    });
                    if (item.dvdd_h === props.thongTin.dvdd_h) {
                        setSelectedDvdd({
                            value: item.dvdd_h,
                            label: item.dvdd_h,
                            pctuoi: item.phancaptuoi,
                            pcdoc: item.phancapdoc,
                            pctpcg: item.phancaptpcg,
                            pcdalan: item.phancapdalan,
                            pcdoday: item.phancapdoday,
                            pcfe: item.phancapfe,
                            tuoi: item.tuoi,
                            dodoc: item.dodoc,
                            tpcg: item.tpcg,
                            dalan: item.dalan,
                            doday: item.doday,
                            dophi: item.dophi,
                        });

                        selectTuoi(item.phancaptuoi)
                        selectDalan(item.phancapdalan);
                        selectDay(item.phancapdoday);
                        selectDoc(item.phancapdoc);
                        selectFe(item.phancapfe);
                        selectTpcg(item.phancaptpcg);
                    }

                });


                setListDvdd(list);
                setShow(true);

                //     let index = res[0].rows.findIndex(x => x.value === props.thongTin.maDaLan);
                //     if (index !== -1) {
                //         setSelectedDaLan(res[0].rows[index]);
                //     }
                //     index = res[1].rows.findIndex(x => x.value === props.thongTin.maDHTD);
                //     if (index !== -1) {
                //         setSelectedDiaHinh(res[1].rows[index]);
                //     }
                //     index = res[2].rows.findIndex(x => x.value === props.thongTin.maDoDay);
                //     if (index !== -1) {
                //         setSelectedDoDay(res[2].rows[index]);
                //     }
                //     index = res[3].rows.findIndex(x => x.value === props.thongTin.maDoDoc);
                //     if (index !== -1) {
                //         setSelectedDoDoc(res[3].rows[index]);
                //     }
                //     index = res[4].rows.findIndex(x => x.value === props.thongTin.maDoPhi);
                //     if (index !== -1) {
                //         setSelectedDoPhi(res[4].rows[index]);
                //     }
                //     index = res[5].rows.findIndex(x => x.value === props.thongTin.maGley);
                //     if (index !== -1) {
                //         setSelectedGley(res[0].rows[index]);
                //     }
                //     index = res[6].rows.findIndex(x => x.value === props.thongTin.maTieu);
                //     if (index !== -1) {
                //         setSelectedTieu(res[0].rows[index]);
                //     }
                //     index = res[7].rows.findIndex(x => x.value === props.thongTin.maTuoi);
                //     if (index !== -1) {
                //         setSelectedTuoi(res[0].rows[index]);
                //     }
            })
            // BanDoChatLuongDatApi.getAllDanhMuc().then((res) => {
            //    
            // })
        }

    }, [props.showModal]);



    const onChangeXa = (e) => {
        setXa(e);
    }

    const onChangeDvdd = (e) => {
        setSelectedDvdd(e);
        selectTuoi(e.pctuoi);
        selectDalan(e.pcdalan);
        selectDay(e.pcdoday);
        selectDoc(e.pcdoc);
        selectFe(e.pcfe);
        selectTpcg(e.pctpcg);
    }

    const onSubmit = (data) => {

        try {

            data.maxa = xa?.value;
            data.tenxa = xa?.label;
            data.id = props.thongTin.id;
            data.dvdd_h = selectedDvdd?.value;
            data.dt_ha = props.thongTin.dt_ha;
            data.dungtichha = props.thongTin.dungtichha;
            data.donobazo = props.thongTin.donobazo;
            data.tongcation = props.thongTin.tongcation;
            data.oc = props.thongTin.tongcation;
            data.phkcl = props.thongTin.phkcl;
            data.tuoi = selectedDvdd?.tuoi;
            data.do_doc = selectedDvdd?.dodoc;
            data.tpcg = selectedDvdd?.tpcg;
            data.tang_day = selectedDvdd?.doday;
            data.da_lan = selectedDvdd?.dalan;
            data.fe = selectedDvdd?.dophi;
            setLoading(true);
            if (data.id != null) {
                console.log(data);
                BanDoChatLuongDatApi.update(data).then((res) => {
                    ThongBao.printSuccessMessage('Cập nhật thành công!');
                    handleClose();
                    props.changeMapComplete();
                    setLoading(false);
                }, (err) => {
                    setLoading(false);
                    ThongBao.printErrorMessage(err);
                });
            }
            else {
                console.log('noid');
            }
        }
        catch (ex) {
        }

    }

    return (
        <Modal size='lg' dialogclassName="modalTK" show={show} onHide={handleClose} backdrop="static" keyboard={false} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Thông tin chất lượng đất đai</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="user">
                    {/* <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Huyện</label>
                        <div className="col-sm-10">
                            <SelectHuyen maHuyen={props.thongTin.maHuyen} onChangeHuyenProps={(e) => onChangeHuyen(e)}></SelectHuyen>
                        </div>
                    </div> */}
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Xã</label>
                        <div className="col-sm-10">
                            <SelectXa Ma={props.thongTin.maxa} onChangeXaProps={(e) => onChangeXa(e)}></SelectXa>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Mã đơn vị đất đai</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dvdd"
                                placeholder="Chọn mã dvdd"
                                value={selectedDvdd}
                                onChange={onChangeDvdd}
                                options={listDvdds}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Diện tích</label>
                        <div className="col-sm-4">
                            <input name="dt_ha" type="text" className="form-control" placeholder="Diện tích" ref={register} />
                        </div>
                        {/* <label className="col-sm-2 col-form-label text-right">Độ dày tầng đất</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="doday"
                                placeholder="Chọn độ dày tầng đất"
                                value={selectedDoDay}
                                onChange={(e) => { setSelectedDoDay(e) }}
                                options={listDoDays}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div> */}
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Dung tích</label>
                        <div className="col-sm-4">
                            <input name="dungtichha" type="text" className="form-control" placeholder="dung tích" ref={register} />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Bazo</label>
                        <div className="col-sm-4">
                            <input name="donobazo" type="text" className="form-control" placeholder="Bazo" ref={register} />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Tổng cation</label>
                        <div className="col-sm-4">
                            <input name="tongcation" type="text" className="form-control" placeholder="Tổng cation" ref={register} />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Phkcl</label>
                        <div className="col-sm-4">
                            <input name="phkcl" type="text" className="form-control" placeholder="Phkcl" ref={register} />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Chế độ tưới</label>
                        <div className="col-sm-4">
                            <input name="tuoi" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={tuoi} disabled />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Độ dày tâng đất</label>
                        <div className="col-sm-4">
                            <input name="doday" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={day} disabled />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Mức độ đá lẫn</label>
                        <div className="col-sm-4">
                            <input name="dalan" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={dalan} disabled />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Độ dốc</label>
                        <div className="col-sm-4">
                            <input name="dodoc" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={doc} disabled />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Độ phì</label>
                        <div className="col-sm-4">
                            <input name="fe" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={fe} disabled />
                        </div>

                        <label className="col-sm-2 col-form-label text-right">Thành phần cơ giới</label>
                        <div className="col-sm-4">
                            <input name="tpcg" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} value={tpcg} disabled />
                        </div>
                    </div>
                    {/* <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Diện tích</label>
                        <div className="col-sm-4">
                            <input name="DienTich" type="text" className="form-control" placeholder="Diện tích" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">Độ dốc</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dodoc"
                                placeholder="Chọn độ dốc"
                                value={selectedDoDoc}
                                onChange={(e) => { setSelectedDoDoc(e) }}
                                options={listDoDocs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>

                   
                        <label className="col-sm-2 col-form-label text-right">Chế độ tiêu</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="tieu"
                                placeholder="Chọn chế độ tiêu"
                                value={selectedTieu}
                                onChange={(e) => { setSelectedTieu(e) }}
                                options={listTieus}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Địa hình tương đối</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="diahinh"
                                placeholder="Chọn địa hình tương đối"
                                value={selectedDiaHinh}
                                onChange={(e) => { setSelectedDiaHinh(e) }}
                                options={listDiaHinhs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">Mức độ đá lẫn</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dalan"
                                placeholder="Chọn mức độ đá lẫn"
                                value={selectedDaLan}
                                onChange={(e) => { setSelectedDaLan(e) }}
                                options={listDaLans}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Mức độ gley</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="gley"
                                placeholder="Chọn mức độ gley"
                                value={selectedGley}
                                onChange={(e) => { setSelectedGley(e) }}
                                options={listGleys}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">Độ phì</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dophi"
                                placeholder="Chọn độ phì"
                                value={selectedDoPhi}
                                onChange={(e) => { setSelectedDoPhi(e) }}
                                options={listDoPhis}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div> */}
                    {/* </div> */}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-group row">
                    <a href="#" type="button" className="btn btn-info btn-sm ml-1" onClick={handleSubmit(onSubmit)}><i className='fas fa-save'></i> Lưu</a>
                    <a href="#" type="button" className="btn btn-danger btn-sm ml-1" onClick={handleClose} disabled><i className="fas fa-sign-out-alt"></i> Hủy</a>
                </div>
            </Modal.Footer>
            <Loading loading={loading}></Loading>
        </Modal>
    );
};